export class Prestacion {
  private prestacion_codigo: number;
  private prestacion_descripcion: string;
  private preparaciones: string;
  private conservaciones: string;
  private tiempo_maximo_proceso: number;

  constructor(
    prestacion_codigo: number,
    prestacion_descripcion: string,
    preparaciones: string,
    conservaciones: string,
    tiempo_maximo_proceso: number
  ) {
    this.prestacion_codigo = prestacion_codigo;
    this.prestacion_descripcion = prestacion_descripcion;
    this.preparaciones = preparaciones;
    this.conservaciones = conservaciones;
    this.tiempo_maximo_proceso = tiempo_maximo_proceso;
  }

  // Getters
  public getPrestacionCodigo(): number {
    return this.prestacion_codigo;
  }

  public getPrestacionDescripcion(): string {
    return this.prestacion_descripcion;
  }

  public getPreparaciones(): string {
    return this.preparaciones;
  }

  public getConservaciones(): string {
    return this.conservaciones;
  }

  public getTiempoMaximoProceso(): number {
    return this.tiempo_maximo_proceso;
  }

  // Setters
  public setPrestacionCodigo(codigo: number): void {
    this.prestacion_codigo = codigo;
  }

  public setPrestacionDescripcion(descripcion: string): void {
    this.prestacion_descripcion = descripcion;
  }

  public setPreparaciones(preparaciones: string): void {
    this.preparaciones = preparaciones;
  }

  public setConservaciones(conservaciones: string): void {
    this.conservaciones = conservaciones;
  }

  public setTiempoMaximoProceso(tiempo: number): void {
    this.tiempo_maximo_proceso = tiempo;
  }

  // Método para devolver una representación en string del objeto
  public toString(): string {
    return `Prestacion: [Código: ${this.prestacion_codigo}, Descripción: ${this.prestacion_descripcion}, Preparaciones: ${this.preparaciones}, Conservaciones: ${this.conservaciones}, Tiempo Máximo Proceso: ${this.tiempo_maximo_proceso}]`;
  }

  // Método estático para convertir una colección de objetos en instancias de Prestacion
  public static fromCollection(data: any[]): Prestacion[] {
    return data.map(
      (item) =>
        new Prestacion(
          item.prestacion_codigo,
          item.prestacion_descripcion,
          item.preparaciones,
          item.conservaciones,
          item.tiempo_maximo_proceso
        )
    );
  }
}
